'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UITabs from 'UIComponents/nav/UITabs';
import UITab from 'UIComponents/nav/UITab';
import { Tabs } from '../Constants';
import { changeTab } from '../actions/Actions';
import { getSearchQueryFromUrl } from '../selectors/Query';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TabTitle = tab => /*#__PURE__*/_jsx(FormattedMessage, {
  message: `FileManagerDashboard.tabs.${tab}`
});
class PageTabs extends Component {
  render() {
    const {
      activeTab,
      onChangeTab,
      searchQuery
    } = this.props;
    const onSelectedChange = e => onChangeTab(e.target.value, searchQuery);
    return /*#__PURE__*/_jsxs(UITabs, {
      selected: activeTab,
      onSelectedChange: onSelectedChange,
      children: [/*#__PURE__*/_jsx(UITab, {
        "data-test-id": "dashboard-tab",
        tabId: Tabs.DASHBOARD,
        title: TabTitle(Tabs.DASHBOARD)
      }), /*#__PURE__*/_jsx(UITab, {
        "data-test-id": "shutterstock-tab",
        tabId: Tabs.STOCK_IMAGES,
        title: TabTitle(Tabs.STOCK_IMAGES)
      })]
    });
  }
}
PageTabs.propTypes = {
  activeTab: PropTypes.oneOf(Object.keys(Tabs)).isRequired,
  searchQuery: PropTypes.string,
  onChangeTab: PropTypes.func.isRequired
};
const mapStateToProps = (state, ownProps) => ({
  searchQuery: getSearchQueryFromUrl(state, ownProps)
});
const mapDispatchToProps = dispatch => ({
  onChangeTab(tabId, searchQuery) {
    dispatch(changeTab(tabId, searchQuery));
  }
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageTabs));